import { useTranslation } from 'react-i18next';

/** Финальный блок (`section#final` макета). */
export function Final() {
  const { t } = useTranslation('landing');
  return (
    <section className="final" id="final">
      <div className="bg" />
      <i className="ico i-nl big" />
      <div className="content">
        <h2 className="rv">{t('final.title')}</h2>
        <a className="btn light magnet rv d1" href="#gifts">
          {t('final.cta')}
        </a>
      </div>
    </section>
  );
}
